const constants = {
  IS_LOGGED_IN: 'is_logged_in',
  AUTH_TOKEN: 'authToken',
  WIRE_TRANSFER: {
    TIMEOUT_HOURS: Number(
      process.env.NEXT_PUBLIC_WIRE_TRANSFER_TIMEOUT_HOURS ?? 120,
    ),
  },
}

export default constants
